export const IMAGE_ZOOM_STEP = 0.25;
export const IMAGE_MIN_ZOOM = 0.5;
export const IMAGE_MAX_ZOOM = 3;
export const IMAGE_VIEWER_PADDING = 32;
export const IMAGE_RESIZE_OVERLAY_MS = 180;
export const IMAGE_INITIAL_RESIZE_OVERLAY_DELAY_MS = 600;
export const IMAGE_RESIZE_THRESHOLD_PX = 2;
